import { staffAttentionSummarySchema } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffAttentionApi(options) {
    const send = createMemoryTransport(options);
    return {
        summary: (callOptions) => send({
            method: "GET",
            path: "/staff/attention",
            schema: staffAttentionSummarySchema,
            signal: callOptions?.signal,
        }),
    };
}
